import { render, staticRenderFns } from "./ChatFix.vue?vue&type=template&id=7514b615&scoped=true"
import script from "./ChatFix.vue?vue&type=script&lang=js"
export * from "./ChatFix.vue?vue&type=script&lang=js"
import style0 from "./ChatFix.vue?vue&type=style&index=0&id=7514b615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7514b615",
  null
  
)

export default component.exports